import axios from 'axios';

// CRA only reads .env when the dev server starts, so fall back to the production FastAPI server.
export const FAST_API_ENDPOINT = process.env.REACT_APP_FAST_API_ENDPOINT || 'https://fast.nivaancare.co.in/api/v1/';

const fastAuthAPI = axios.create({
  baseURL: FAST_API_ENDPOINT,
});

fastAuthAPI.interceptors.request.use((request) => {
  request.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return request;
});

// Token refresh is handled against the main (Django) backend, since login/auth
// still lives there regardless of which backend serves a given resource.
const handle401Error = async () => {
  await axios
    .post(process.env.REACT_APP_API_ENDPOINT + 'token/refresh/', {
      refresh: localStorage.getItem('refreshToken'),
    })
    .then((res) => {
      localStorage.setItem('token', res.data.access);
      window.location.reload();
    })
    .catch((err) => {
      localStorage.clear();
      window.location.href = '/';
    });
};

fastAuthAPI.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status == 401) {
      return handle401Error();
    } else {
      return Promise.reject(error);
    }
  }
);

export default fastAuthAPI;
